import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
  },
});

// iPEN portal product logo (collapsed sidebar shows just the mark).
// Source: https://theme.ipen.eon.com/logos/product_logos/logo_ipen_portal.svg
export const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 53.8 53.85"
    >
      <path
        fill="#e53323"
        d="m26.95,53.85c-5.9,0-11.9-.6-17.8-1.7-3.8-.7-6.8-3.7-7.5-7.5C-.55,32.85-.55,20.85,1.65,9.15c.7-3.8,3.7-6.8,7.5-7.5h0C20.95-.55,32.95-.55,44.65,1.65c3.8.7,6.8,3.7,7.5,7.5,2.2,11.8,2.2,23.8,0,35.5-.7,3.8-3.7,6.8-7.5,7.5-5.9,1.1-11.8,1.7-17.7,1.7ZM9.55,3.55c-3,.6-5.4,2.9-5.9,5.9-2.2,11.5-2.2,23.3,0,34.8.6,3,2.9,5.4,5.9,5.9,11.5,2.2,23.3,2.2,34.8,0,3-.6,5.4-2.9,5.9-5.9,2.2-11.5,2.2-23.3,0-34.8-.6-3-2.9-5.4-5.9-5.9-11.6-2.2-23.3-2.2-34.8,0h0Z"
      />
      <path fill="#e53323" d="M10.59 22.96H43.19V30.66H10.59z" />
      <path
        fill="#e53323"
        d="m41.25,36.45v3.7H12.55v-3.7h28.7m2-2H10.65v7.7h32.6v-7.7h0Z"
      />
      <path
        fill="#e53323"
        d="m41.25,13.55v3.7H12.55v-3.7h28.7m2-1.9H10.65v7.7h32.6v-7.7h0Z"
      />
    </svg>
  );
};